{
  "actionbar.actions": "Действия",
  "actionbar.actionsAvailable": "Налични действия.",
  "actionbar.clearSelection": "Изчистване на избора",
  "actionbar.selected": "{count, plural, =0 {Няма избрани} one {# избран} other {# избрани}}",
  "actionbar.selectedAll": "Всички избрани",
  "button.pending": "недовършено",
  "calendar.invalidSelection": "{selectedCount, plural, one {Избраната дата не е налична} other {Избраните дати не са налични}}.",
  "contextualhelp.help": "Помощ",
  "contextualhelp.info": "Информация",
  "datepicker.endTime": "Краен час",
  "datepicker.startTime": "Начален час",
  "datepicker.time": "Време",
  "dialog.alert": "Сигнал",
  "dialog.dismiss": "Отхвърляне",
  "dropzone.replaceMessage": "Пуснете файл за замяна",
  "inlinealert.informative": "Информация",
  "inlinealert.negative": "Грешка",
  "inlinealert.notice": "Предупреждение",
  "inlinealert.positive": "Успешно",
  "label.(optional)": "(незадължително)",
  "label.(required)": "(задължително)",
  "menu.moreActions": "Повече действия",
  "picker.placeholder": "Изберете…",
  "slider.maximum": "Максимум",
  "slider.minimum": "Минимум",
  "table.loading": "Зареждане...",
  "table.loadingMore": "Зареждане на още...",
  "table.resizeColumn": "Преоразмеряване на колона",
  "table.sortAscending": "Възходящо сортиране",
  "table.sortDescending": "Низходящо сортиране ",
  "tag.actions": "Действия",
  "tag.hideButtonLabel": "Показване на по-малко",
  "tag.noTags": "Нито един",
  "tag.showAllButtonLabel": "Показване на всички ({tagCount, number})",
  "breadcrumbs.more": "Още елементи",
  "combobox.noResults": "Няма резултати",
  "notificationbadge.indicatorOnly": "Нова дейност",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}